import React from 'react';

import i18n from 'util/i18n';
import { DateSummary, Summary } from 'components/Summary';

import { SUBSTANCE_USE, SUBSTANCE_USE_THC_USAGE } from 'config/formSections/substanceUse';
import { formConfig } from 'config/forms';
import { getNumberOfYearsString } from 'helpers/text';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import ThcUseItem from './ThcUseItem';

const sectionConfig = {
  key: SUBSTANCE_USE_THC_USAGE.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_THC_USAGE.name,
  storeKey: SUBSTANCE_USE_THC_USAGE.storeKey,
};

export class ThcUses extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateList = this.updateList.bind(this);
    this.updateUsedThc = this.updateUsedThc.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (updateValues) => {
    this.props.onUpdate(this.storeKey, {
      UsedThc: this.props.UsedThc,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...updateValues,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateUsedThc = (values) => {
    this.update({
      UsedThc: values,
      List: values.value === 'Yes' ? this.props.List : {},
      SummaryComments: values.value === 'Yes' ? this.props.SummaryComments : {},
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const first = DateSummary(o.FirstUse);
    const last = DateSummary(o.RecentUse);

    return Summary({
      type: i18n.t('substance.pvq.thc.use.collection.itemType'),
      index,
      left: first,
      right: last,
      placeholder: i18n.t('substance.pvq.thc.use.collection.summary'),
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  render() {
    const {
      formType,
      formVersion,
      requireThcWhileSafety,
      requireThcWithClearance,
      requireThcInFuture,
      errors,
    } = this.props;
    const formTypeConfig = formType && formConfig[formType];
    const years = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_USE_YEARS;
    const numberOfYearsString = getNumberOfYearsString(years);

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content thc-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_THC_USAGE.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.drugs.usage')}</h1>
        <Branch
          {...this.props.UsedThc}
          name="UsedThc"
          attribute="UsedThc"
          label={i18n.t('substance.pvq.thc.heading.thcUses', { numberOfYearsString })}
          labelSize="h4"
          className="used-drugs"
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateUsedThc}
          scrollIntoView={this.props.scrollIntoView}
        />

        <Show when={this.props.UsedThc.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('substance.pvq.thc.use.collection.description')}
            appendTitle={i18n.t('substance.pvq.thc.use.collection.appendTitle')}
            appendLabel={i18n.t('substance.pvq.thc.use.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <ThcUseItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              requireThcWhileSafety={requireThcWhileSafety}
              requireThcWithClearance={requireThcWithClearance}
              requireThcInFuture={requireThcInFuture}
              formType={formType}
              formVersion={formVersion}
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

ThcUses.defaultProps = {
  UsedThc: {},
  List: {},
  Comments: {},
  SummaryComments: {},
  onError: (value, arr) => arr,
  section: 'substance',
  subsection: 'thc/usage',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(ThcUses, sectionConfig);
